import { Segment, TextSegments } from 'ui/workflows/flowchart';
import { NODE_TYPES, WORKFLOW_ACTIONS } from '../../constants';
import { AddContactNodeData, ChangeContactFieldNodeData, RemoveContactNodeData } from '../../types';

const introText = {
  [NODE_TYPES.ADD_CONTACT]: 'Added to',
  [NODE_TYPES.REMOVE_CONTACT]: 'Removed from',
};

const getChangeFieldSegments = (dataFields: any): Segment =>
  dataFields
    ? { text: JSON.stringify(dataFields), tooltipText: JSON.stringify(dataFields, undefined, 2) }
    : { text: '' };

const changeField = {
  isSetup: ({ nodeClass, dataFields, endpoint }: ChangeContactFieldNodeData): boolean =>
    nodeClass === WORKFLOW_ACTIONS.UPDATE_CONTACT_WEBHOOK
      ? !!endpoint
      : typeof dataFields === 'object',
  getTextSegments: ({
    nodeClass,
    dataFields,
    endpoint,
  }: ChangeContactFieldNodeData): TextSegments => {
    const segments =
      nodeClass === WORKFLOW_ACTIONS.UPDATE_CONTACT_WEBHOOK
        ? [{ text: endpoint || '' }]
        : [getChangeFieldSegments(dataFields)];

    return {
      nodeDescBottom: {
        isTruncated: true,
        segments,
        showTooltipIfTruncated: true,
      },
    };
  },
};

type ModifyListDescriptionProps = {
  resource: RemoveContactNodeData['resource'] | AddContactNodeData['resource'];
  actionDescription?: string;
  emailListId?: number | null;
  emailListIds?: number[];
};

const getModifyListDescription = ({
  resource,
  actionDescription,
  emailListId,
  emailListIds,
}: ModifyListDescriptionProps) => {
  const singleSegments = [[{ text: actionDescription || '' }], [{ text: resource?.name || '' }]];
  const combinedListIds = [
    ...new Set([...(emailListId ? [emailListId] : []), ...(emailListIds ?? [])]),
  ];
  const text = `${actionDescription || ''} ${combinedListIds.length} ${combinedListIds.length === 1 ? 'list' : 'lists'}`;
  const multiSegments = [
    emailListIds?.length
      ? {
          text,
          tooltipText: `${emailListIds?.join('\n')}`,
        }
      : { text },
  ];

  return {
    nodeDescBottom: {
      isTruncated: true,
      showTooltipIfTruncated: true,
      segments: !!resource && !emailListIds ? singleSegments : multiSegments,
    },
  };
};

const removeContact = {
  getDescription: ({ resource, emailListIds, emailListId }: RemoveContactNodeData) =>
    getModifyListDescription({
      resource,
      actionDescription: introText[NODE_TYPES.REMOVE_CONTACT],
      emailListId,
      emailListIds,
    }),
};

const addContact = {
  getDescription: ({ resource, emailListIds, emailListId }: AddContactNodeData) =>
    getModifyListDescription({
      resource,
      actionDescription: introText[NODE_TYPES.ADD_CONTACT],
      emailListId,
      emailListIds,
    }),
};

export const contactActionUtils = {
  changeField,
  removeContact,
  addContact,
  introText,
};

export default contactActionUtils;
